/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useAsyncEffect } from 'src/core/hooks/useAsyncEffect';
import { getCompositeEntityService } from 'src/luis/core/services/entities/compositeEntityService';
import { useCurrentVersionedAppId } from 'src/luis/modules/apps/hooks/useCurrentVersionedAppId';
import { CompositeEntityStore } from 'src/luis/types/stores/entities/CompositeEntityStore';

/**
 * Loads the dependencies of te entity migration process.
 */
export const useCompositeEntityMigrationDependencies = () => {
    const { appId, versionId } = useCurrentVersionedAppId();

    const [compositeEntities, setCompositeEntities] = React.useState<CompositeEntityStore[]>([]);

    useAsyncEffect(async () => {
        if (versionId) {
            setCompositeEntities(await getCompositeEntityService({ context: { appId, versionId } }).getEntities());
        }
    }, [versionId]);

    return { compositeEntities };
};
